export interface RadioCommunityStats {
  id: number;
  radioName: string;
  radioFrequency: string;
  radioCity: string;
  activeHosts: number;
  activePrograms: number;
  activeListeners: number;
  greetings: number;
  songRequests: number;
  activeChats: number;
  totalInteractions: number;
  communityScore: number;
  trending: boolean;
  lastActivity: string;
}

export const radioCommunityStats: RadioCommunityStats[] = [
  {
    id: 1,
    radioName: 'Radio Éxito FM',
    radioFrequency: '98.5 FM',
    radioCity: 'Ciudad de México',
    activeHosts: 8,
    activePrograms: 12,
    activeListeners: 42000,
    greetings: 14500,
    songRequests: 3200,
    activeChats: 28,
    totalInteractions: 59700,
    communityScore: 94,
    trending: true,
    lastActivity: 'Hace 2 min',
  },
  {
    id: 2,
    radioName: 'Radio Estéreo Capital',
    radioFrequency: '102.1 FM',
    radioCity: 'Medellín',
    activeHosts: 6,
    activePrograms: 9,
    activeListeners: 31000,
    greetings: 11200,
    songRequests: 2800,
    activeChats: 22,
    totalInteractions: 45000,
    communityScore: 88,
    trending: true,
    lastActivity: 'Hace 5 min',
  },
  {
    id: 3,
    radioName: 'Radio Cultura Digital',
    radioFrequency: '91.3 FM',
    radioCity: 'Buenos Aires',
    activeHosts: 5,
    activePrograms: 8,
    activeListeners: 24000,
    greetings: 8900,
    songRequests: 1800,
    activeChats: 16,
    totalInteractions: 34700,
    communityScore: 82,
    trending: false,
    lastActivity: 'Hace 8 min',
  },
  {
    id: 4,
    radioName: 'Radio Deportiva Total',
    radioFrequency: '95.7 FM',
    radioCity: 'Guadalajara',
    activeHosts: 7,
    activePrograms: 10,
    activeListeners: 38000,
    greetings: 13800,
    songRequests: 2200,
    activeChats: 24,
    totalInteractions: 54000,
    communityScore: 91,
    trending: true,
    lastActivity: 'Hace 1 min',
  },
  {
    id: 5,
    radioName: 'Radio Peninsular',
    radioFrequency: '101.9 FM',
    radioCity: 'Mérida',
    activeHosts: 4,
    activePrograms: 6,
    activeListeners: 18000,
    greetings: 6200,
    songRequests: 1400,
    activeChats: 12,
    totalInteractions: 25600,
    communityScore: 74,
    trending: false,
    lastActivity: 'Hace 15 min',
  },
  {
    id: 6,
    radioName: 'Radio Costa Azul',
    radioFrequency: '88.7 FM',
    radioCity: 'San José',
    activeHosts: 5,
    activePrograms: 7,
    activeListeners: 21000,
    greetings: 7800,
    songRequests: 1600,
    activeChats: 14,
    totalInteractions: 30400,
    communityScore: 79,
    trending: false,
    lastActivity: 'Hace 10 min',
  },
  {
    id: 7,
    radioName: 'Radio Industria',
    radioFrequency: '93.5 FM',
    radioCity: 'Monterrey',
    activeHosts: 6,
    activePrograms: 9,
    activeListeners: 28000,
    greetings: 10200,
    songRequests: 2400,
    activeChats: 19,
    totalInteractions: 40600,
    communityScore: 85,
    trending: true,
    lastActivity: 'Hace 3 min',
  },
  {
    id: 8,
    radioName: 'Radio TechBeats',
    radioFrequency: '97.3 FM',
    radioCity: 'San Salvador',
    activeHosts: 4,
    activePrograms: 7,
    activeListeners: 19500,
    greetings: 7100,
    songRequests: 2100,
    activeChats: 15,
    totalInteractions: 28700,
    communityScore: 76,
    trending: false,
    lastActivity: 'Hace 20 min',
  },
  {
    id: 9,
    radioName: 'Radio Élite Digital',
    radioFrequency: '99.1 FM',
    radioCity: 'Madrid',
    activeHosts: 7,
    activePrograms: 11,
    activeListeners: 35000,
    greetings: 12800,
    songRequests: 3000,
    activeChats: 25,
    totalInteractions: 50800,
    communityScore: 92,
    trending: true,
    lastActivity: 'Ahora',
  },
  {
    id: 10,
    radioName: 'Radio Nueva Actitud',
    radioFrequency: '94.2 FM',
    radioCity: 'Lima',
    activeHosts: 5,
    activePrograms: 8,
    activeListeners: 22000,
    greetings: 8100,
    songRequests: 1750,
    activeChats: 13,
    totalInteractions: 31850,
    communityScore: 77,
    trending: false,
    lastActivity: 'Hace 25 min',
  },
  {
    id: 11,
    radioName: 'Radio Clásica FM',
    radioFrequency: '100.5 FM',
    radioCity: 'Bogotá',
    activeHosts: 4,
    activePrograms: 6,
    activeListeners: 16500,
    greetings: 5400,
    songRequests: 1200,
    activeChats: 10,
    totalInteractions: 23100,
    communityScore: 70,
    trending: false,
    lastActivity: 'Hace 30 min',
  },
  {
    id: 12,
    radioName: 'Radio Tropical Mix',
    radioFrequency: '96.8 FM',
    radioCity: 'Santiago',
    activeHosts: 6,
    activePrograms: 9,
    activeListeners: 26000,
    greetings: 9500,
    songRequests: 2600,
    activeChats: 18,
    totalInteractions: 38100,
    communityScore: 83,
    trending: false,
    lastActivity: 'Hace 12 min',
  },
];

export const communityMetrics = {
  totalActiveRadios: 12,
  totalActiveHosts: 67,
  totalActivePrograms: 102,
  totalActiveListeners: 323000,
  totalGreetings: 115600,
  totalSongRequests: 26050,
  totalActiveChats: 216,
  totalInteractions: 464650,
  avgCommunityScore: 83,
  peakActivityHour: '20:00 - 22:00',
  topInteractionType: 'Saludos',
  mostActiveCity: 'Ciudad de México',
};